import { render, staticRenderFns } from "./tabelaDiarias.vue?vue&type=template&id=b112ea86&scoped=true"
import script from "./tabelaDiarias.vue?vue&type=script&lang=js"
export * from "./tabelaDiarias.vue?vue&type=script&lang=js"
import style0 from "./tabelaDiarias.vue?vue&type=style&index=0&id=b112ea86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b112ea86",
  null
  
)

export default component.exports